import * as React from "react";
import { Alert, Col, Row } from "components/bootstrap";
import useLicenseCheck from "license/useLicenseCheck";
import LicenseHelp from "license/notifications/LicenseHelp";
const Status = () => /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", title: "Asset Events are disabled" }, /* @__PURE__ */ React.createElement("p", null, "Asset Event definitions are disabled due to the absence of a valid Security license. It is still possible to update any existing definitions, but new Alerts and Events will not be generated from them."), /* @__PURE__ */ React.createElement(LicenseHelp, null));
const EventsSecurityLicenseStatus = ({ summary = false, children = void 0 }) => {
  const {
    security: { isValid }
  } = useLicenseCheck();
  if (summary) return /* @__PURE__ */ React.createElement(Status, null);
  return /* @__PURE__ */ React.createElement(Row, { className: "row-sm" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, isValid ? children : /* @__PURE__ */ React.createElement(Status, null)));
};
export default EventsSecurityLicenseStatus;
